// IMPORTANT! We should not add slick carousel here, because it is already added in app.js.
// Also do not require jquery, because it is already injected by webpack
//const $ = require('jquery');
//require('slick-carousel');
//require('intersection-observer');

export class moreBookingsCarousel {

    constructor(options) {
        this.options = $.extend({
            node: $('.book-sl--main')
        }, options);

        var instance =this;
        var observer = new IntersectionObserver(function (data) {
            $(data).each(function () {
                if (this.isIntersecting) {
                    observer.unobserve(this.target);
                    instance.initCarousel();
                }
            });
        });
        observer.POLL_INTERVAL = 100;
        observer.USE_MUTATION_OBSERVER = true;

        $('#more-bookings').each(function () {
            observer.observe(this);
        });
    }

	initCarousel () {
		const main = $('.book-sl--main');
		const nav = $('.book-sl--nav');

		if (typeof main.slick !== 'function') {
			console.warn('moreBookingsCarousel: slick not loaded yet, retrying…');
			setTimeout(() => this.initCarousel(), 200);
			return;
		}

		const mainBookCarousel = main.slick({
			autoplay: true,
			autoplaySpeed: 3000,
			pauseOnFocus: true,
			pauseOnHover: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '.book-sl--nav',
			accessibility: false
		});

		const navMainBookCarousel = nav.slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			asNavFor: '.book-sl--main',
			dots: false,
			centerMode: true,
			focusOnSelect: true,
			responsive: [
				{ breakpoint: 768, settings: { arrows: false, slidesToShow: 3, variableWidth: true } }
			]
		});

		main.on('init afterChange', (e, slick, currentSlide) => {
			const slides = $(slick.$slides);
			slides.attr({ 'aria-selected': 'false', 'tabindex': '-1' });
			const current = currentSlide ?? slick.currentSlide;
			slides.eq(current).attr({ 'aria-selected': 'true', 'tabindex': '0' });

			$('#more-bookings')
				.attr('aria-label', `More booking channels carousel, slide ${current + 1} of ${slick.slideCount}`);
		});

		// pause/resume autoplay on hover
		nav.on('mouseover', () => mainBookCarousel.slick('slickPause'));
		nav.on('mouseout', () => mainBookCarousel.slick('slickPlay'));
		this.addAccessibility(nav, main);

		nav.find('.book-sl--nav-item').each(function (index) {
			$(this).attr('aria-controls', `carousel-slide-${index + 1}`);
		});
		main.find('.book-sl--item-main').each(function (index) {
			$(this).attr('id', `carousel-slide-${index + 1}`);
		});
	}

	addAccessibility(nav, main) {
		//update aria attributes for slides and tab
		main.on('afterChange', (e, slick, current) => {
			const options = $(slick.$slides).find('[role="option"]');
			options.attr('aria-selected', 'false');
			$(options[current]).attr('aria-selected', 'true');

			// Оновлюємо aria-label для регіону
			const total = slick.slideCount;
			$('#more-bookings')
				.attr('aria-label', `More booking channels carousel, slide ${current + 1} of ${total}`);
		});

		// keyboard navigation for nav items (ArrowLeft, ArrowRight, Enter, Space)
		nav.on('keydown', '.book-sl--nav-item', function (e) {
			const items = nav.find('.book-sl--nav-item');
			const currentIndex = items.index(this);

			if (e.key === 'ArrowRight') {
				e.preventDefault();
				const next = (currentIndex + 1) % items.length;
				items.eq(next).focus().click();
			} else if (e.key === 'ArrowLeft') {
				e.preventDefault();
				const prev = (currentIndex - 1 + items.length) % items.length;
				items.eq(prev).focus().click();
			}
		});

		// allow nav items to be focusable and set initial aria-selected
		nav.find('.book-sl--nav-item').attr({
			'tabindex': '-1',
			'aria-selected': 'false'
		});

		nav.on('afterChange', (e, slick, current) => {
			const tabs = $(slick.$slides);
			tabs.attr('aria-selected', 'false').attr('tabindex', '-1');
			$(tabs[current]).attr('aria-selected', 'true').attr('tabindex', '0');
		});

		// update initial states for first slide and tab on load
		const firstOption = main.find('[role="option"]').first();
		firstOption.attr('aria-selected', 'true');

		const firstTab = nav.find('.book-sl--nav-item').first();
		firstTab.attr('aria-selected', 'true').attr('tabindex', '0');
	}
}


